export const FinancialControllerTemplate = {

    getFormName() {
        return {
            q1:4600000,
            q2:6400000,
            q3:9800000,
            q4:9200000,

            vpCommentsq1: "We are close to hitting this",
            vpCommentsq2: "Pre Consruction creep has impacted this",
            vpCommentsq3: "Dependent on S&M signing FSA in Q 1 & Q2",
            vpCommentsq4: "Dependent on S&M signing FSA in Q 1 & Q2",
            vpCommentsq5: "",
            
            name:'',
            date:'',
            month:'',
            year_goal:'',
            check_in_how_are_you_doing:'',
            what_can_i_do_support_you:'',
            user_id:'',
            annual_deliverbles:this.annualDeliverbles(),
            primary_task:this.primaryTask(),
            secondry_task:this.secondryTask(),
            any_additional_topics:[{
                title:'',
                comments:'',
               

            }],
            weeks:[{
                finacial_point:48,
                week:this.getDataForAll(),
            }],
            discussion_item:[{
                discussion_items:'',
            }],
            to_discuss:[{
                title:'',
                comments:'',
            }],
            goals_for_the_week:[{
                title:'',
                reason_1:'',
                reason_2:'',
                comments_1:'',
                comments_2:'',
            }],
        }

    },
 
    getDataForAll(){
        var  user_id = localStorage.getItem('user_id');
        return user_id==20? [
            {
                title: "Weekly workload rating 1-10",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Direct report time clock approved everyday <6pm with notes",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Direct report scorecard  filled out <6pm Monday",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Playbook complete <6pm Friday",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Daily outstanding receivables sent out to PM's and VP",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Upload PM's P&L and Billable vs Unbillable time in Workfiles 3rd day of each month",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Prepare WIP Report LIDA Homes Inc. 3rd day of each month",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Worksafe Remittance LIDA Homes Inc. 3rd day of each month",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "RRSP remittance completed LIDA Homes Inc. 7th day of each month",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Extended Health remittance LIDA Homes Inc. 7th day of each month",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Payroll Deducation Remittances LIDA Homes Inc.",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "Monthly/Quaterly/Yearly tasks due",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "EP: Demonstrate Core Values above and beyond - 5 points",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "EP: Demonstrate Core Values Core Value shout out - 1 point",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "CE: Loosing the company >$100 time/materials - 5 points",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            }, {
                title: "CE: Loosing the company >500 time/materials - 20 points",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
        
        
        
        ]: [
            {
                title: "Weekly workload rating 1-10",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Fill out time clock (daily) 5pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Playbook filled out (weekly) 2pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Check admin email box (daily) 5pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Print/ Save invoices from admin email (3x weekly) 3pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Enter job bills into BT/ QB (2x weekly) 4pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Outstanding receivables report sent out (1x week) 2pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Generate and send client invoices 10pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Payment run (2x monthly) 6pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Enter Lida/ Holdings/ Developments bills (2x monthly) 4pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Enter pay & employee expenses (1x monthly) 5pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Run Billable/ Unbillable Report (after payroll) 2pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Process Payroll (bi-weekly) 2pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "Visa Reconciliation 2pts",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "EP: Demonstrate Core Values above and beyond - 5 points",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
            {
                title: "EP: Demonstrate Core Values Core Value shout out - 1 point",
               
                point_1: "",
                point_2: "",
               
                comments: "",
                vp_comments: ""
            },
           
        ];
    },

    annualDeliverbles(){
        return [{
            title:'Schedule and Budget',
            description:'',
            lida_homes_core_value:'Team Players ',
        },
        {
            title:'Customer Service',
            description:'',
            lida_homes_core_value:'Committed to Excellence',
        },
        {
            title:'Training and Pro. Dev.',
            description:'',
            lida_homes_core_value:'We Do What We Say We Are Going To Do',
        },
        {
            title:'Adiminstration',
            description:'',
            lida_homes_core_value:'',
        }
    ]
    },
    primaryTask(){
      var  user_id = localStorage.getItem('user_id');
        return user_id==20?[
            {
                title: 'Upload PM\'s P&L and Billable vs Unbillable time in Workfiles',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            {
                title: 'Prepare WIP Report LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Worksafe Remittance LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'RRSP remittance completed LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Extended Health remittance LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Bank Reconciliations LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Month end Recon worksheet and company adjustements - LC',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'GP Worksheet',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Monthly Financial Statement Report LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Monthly Financial Data entered into Ninety LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'CC Reconciliation LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'POC Monthly',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'A/R Up to Date LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'A/P Up to Date LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Tax Remittance LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'GST Remittance LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Quarterly Financial Statement Report LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'A/P Verification LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Payroll Deducation Remittances LIDA Homes Inc.',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Union Remittances ',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Complete Payroll',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
            {
                title: 'Annual Financial Statement LIDA Group of Companies',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
            
        
        
        ]:[
            {
            title:'Outstanding receivables report sent out',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Run Billable/ Unbillable Report',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Run Profit/ Loss Report',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Generate and send client invoices (Includes clients,Developments, Holdings, Parners)',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Check admin email box ',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Print/ Save invoices from admin email',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Payment Run to Vendors (process all mail etc)',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Enter pay & employee expenses',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Enter job bills into BT/ QB ',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Enter Lida/ Holdings/ Developments bills',
            due_date:'',
            completed:'NO',
            comments:'',
        },
       
    ]
    },
    secondryTask(){
        var  user_id = localStorage.getItem('user_id');
        return user_id==20?[
            {
                title: 'Bank Deposits ',
                due_date: '',
                completed: 'NO',
                comments: '',
            }, {
                title: 'Projects ',
                due_date: '',
                completed: 'NO',
                comments: '',
            }, {
                title: 'CC Payments',
                due_date: '',
                completed: 'NO',
                comments: '',
            }, {
                title: 'Manage Holding/Developments Rental Deposits',
                due_date: '',
                completed: 'NO',
                comments: '',
            }, {
                title: 'Manage Holdings/Developments Financials',
                due_date: '',
                completed: 'NO',
                comments: '',
            },
        
        ]:[
            {
            title:'Fill out time clock everyday',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Playbook filled out weekly',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Manage money required for payment of CC',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Updating QB when payments received from customers via Jetpay or other source',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Project reconcilliations with PM\'s',
            due_date:'',
            completed:'NO',
            comments:'',
        },
        {
            title:'Generate deposit invoices and track deposits for refunds',
            due_date:'',
            completed:'NO',
            comments:'',
        },
    ]},
        
}